<template>
	<div
		v-if="location"
		class="order-box__location"
		:class="{
			'order-box__location--no-click': noClick
		}"
		@click="noClick ? null : $emit('click')"
	>
		<div
			v-if="location.brand || location.image"
			class="order-box__location-image"
		>
			<img
				:src="location.image || themeImagePath(`location-${location.brand}.jpg`)"
				:alt="`${location.brand} image`"
				class="order-box__location-image-element"
			>
			<!-- <img
				v-if="location.brand"
				:src="themeImagePath(`brand-${location.brand}.svg`)"
				:alt="`${location.brand} logo`"
				class="order-box__location-image-logo"
			> -->
			<component
				v-if="location.brand"
				:is="iconComponent(`logo-simple-${location.brand}`)"
				:alt="`${location.brand} logo`"
				class="order-box__location-image-logo"
			/>
		</div>
		<div class="order-box__location-content">
			<h5
				v-if="location.distance"
				class="order-box__location-distance"
				v-html="location.distance"
			/>
			<h4
				class="order-box__location-name"
				v-html="location.name"
			/>

			<ul
				v-if="location.tags.length"
				class="order-box__location-tags"
			>
				<li
					v-for="(tag, index) in location.tags"
					:key="index"
					class="order-box__location-tag"
					v-html="tag"
				/>
			</ul>

			<div
				v-if="shippingMethod === 'takeaway' && location.address"
				class="order-box__location-address"
			>
				<SVGLocation class="order-box__location-address-icon"/>
				<address
					class="order-box__location-address-text"
					v-html="formattedAddress"
				/>
			</div>
			<div
				v-else-if="shippingMethod === 'delivery' && location.uberDirect"
				class="order-box__location-partner"
			>
        <div
          class="order-box__location-partner-text"
          v-html="$t('uberDirect.deliveryBy')"
        />
        <SVGUberDirect class="order-box__location-partner-logo" />
        <!-- <div
          class="order-box__location-partner-text"
          v-html="$t('uberDirect.deliveryAtCheckout')"
        /> -->
			</div>
			<ul
				v-else-if="shippingMethod === 'delivery'"
				class="order-box__location-infos"
			>
				<li
					v-if="location.deliveryTime"
					class="order-box__location-info"
				>
					<SVGClock class="order-box__location-info-icon"/>
					<span
						class="order-box__location-info-text"
						v-html="$t('orderbox.locations.deliveryTime', { minutes: location.deliveryTime })"
					/>
				</li>
				<li
					v-if="location.minDeliveryAmount"
					class="order-box__location-info order-box__location-info--inline"
				>
					<SVGBag class="order-box__location-info-icon"/>
					<span
						class="order-box__location-info-text"
						v-html="$t('orderbox.locations.minDeliveryAmount', { amount: $options.filters.fwgpricecent(location.minDeliveryAmount * 100, 'html') })"
					/>
				</li>
				<li
					v-if="location.deliveryPrice"
					class="order-box__location-info order-box__location-info--inline"
				>
					<SVGDelivery class="order-box__location-info-icon"/>
					<span
						class="order-box__location-info-text"
						v-html="$options.filters.fwgpricecent(location.deliveryPrice * 100, 'html')"
					/>
				</li>
			</ul>
		</div>

	</div>
</template>

<script>
export default {
	props: {
		location: Object,
		shippingMethod: String,
		noClick: Boolean
	},
	computed: {
		formattedAddress() {
			let address = [
				this.location?.address?.street,
				`${this.location?.address?.zip} ${this.location?.address?.city}`
			];

			return address.join('<br>');
		},
	},
}
</script>

<style>

</style>
